var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.772,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon map-parking",
    d: "M7.237 0H0v16h3.52v-5.12h3.717c3.988 0 5.534-3.159 5.534-5.766S11.226 0 7.237 0zm-.964 7.68H3.52v-4.8h2.753c1.636 0 3.094.361 3.094 2.4s-1.458 2.4-3.094 2.4z",
    fill: "#7cba25"
  })));
}

export default SvgMapParking;